var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelephone = function SvgTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telephone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.509.673A1.09 1.09 0 0 0 3.213.04L.807.695A1.097 1.097 0 0 0 0 1.751C0 8.515 5.485 14 12.25 14c.492 0 .924-.33 1.055-.807l.656-2.406a1.09 1.09 0 0 0-.634-1.296l-2.625-1.093a1.09 1.09 0 0 0-1.266.317L8.33 10.063a9.241 9.241 0 0 1-4.394-4.394l1.348-1.102c.375-.306.503-.82.317-1.266L4.51.676V.673Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telephone_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgTelephone;